import { action } from 'mobx';

class Store {
  @action
  setProp(key, value) {
    this[key] = value;
  }

  @action
  setProps(props) {
    Object.keys(props).forEach(key => {
      this.setProp(key, props[key]);
    });
  }
}

export default Store;
